import { BLANK_VALUE } from "../../jobs/helpers/salaryType";

export const JOB_DETAILS_MANDATORY_FIELDS = ["title", "type"];

export const BLANK_LAT_LNG = { lat: 0, lng: 0 };

export const EMPTY_LOCATION = {
  address: "",
  addressType: "",
  areaLevelOne: "",
  countryCode: "",
  latLng: BLANK_LAT_LNG,
  locality: "",
};

export const INITIAL_FORM_VALUES = {
  title: "",
  company: "",
  type: "",
  industry: "",
  salary: {
    type: BLANK_VALUE,
    value: null,
    min: null,
    max: null,
    display: "",
    currency: "",
  },
  description: "",
  jobDescription: {
    url: "",
    filename: "",
  },

  contactName: "",
  contactEmail: "",
  phoneNumber: "",
  location: EMPTY_LOCATION,
  multipleLocations: [],

  contactWebsiteUrl: {
    url: "",
    isApply: true,
  },

  dateExpiring: "",

  companyLogoPhotoURL: "",

  category: "",

  skillTags: [],
};
